module.exports = __webpack_public_path__ + "static/media/bg_6.a9e8fefa.jpg";